function initLogoSliders(sectionId = null) {
  const sliders = sectionId
    ? document.querySelectorAll(`[data-section-id="${sectionId}"][data-logo-slider]`)
    : document.querySelectorAll('[data-logo-slider]');

  const isMobileView = window.innerWidth <= 768;

  sliders.forEach(slider => {
    const existing = Flickity.data(slider);
    if (existing) existing.destroy();

    const sliderEnable = slider.dataset.sliderEnable === 'true';

    // If sliderEnable is false, only enable slider on mobile view
    if (!sliderEnable && !isMobileView) return;

    // Apply custom spacing CSS variable
    slider.style.setProperty('--logo-spacing', `${parseInt(slider.dataset.spacing) || 20}px`);

    const flkty = new Flickity(slider, {
      autoPlay: (parseFloat(slider.dataset.speed) * 1000) || 3000,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      cellAlign: 'right',
      contain: true,
      draggable: true,
      pauseAutoPlayOnHover: true,
      imagesLoaded: true,
    });

    ['pointerup', 'dragEnd'].forEach(evt => {
      slider.addEventListener(evt, () => setTimeout(() => flkty.playPlayer(), 100));
    });

    flkty.resize();
    setTimeout(() => flkty.resize(), 500);
  });
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => initLogoSliders());

// Handle Shopify section and block events
['load', 'unload', 'select', 'deselect', 'reorder'].forEach(event => {
  document.addEventListener(`shopify:section:${event}`, (e) => initLogoSliders(e.detail.sectionId));
});
['select', 'deselect'].forEach(event => {
  document.addEventListener(`shopify:block:${event}`, (e) => initLogoSliders(e.detail.sectionId));
});

// Optional: re-run on resize to enable/disable slider responsively
window.addEventListener('resize', () => {
  initLogoSliders();
});
